// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hMMv","largestCol":"styles_largestCol___IKF4","smallestCol":"styles_smallestCol__36cVy"};